import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ReviewShell } from '../components/signup-review/ReviewShell';
import { AccountDetails } from '../components/signup-review/AccountDetails';
import { BusinessDetails } from '../components/signup-review/BusinessDetails';
import { PlanSelection } from '../components/signup-review/PlanSelection';
import { CheckoutPreview, ConfirmationPreview } from '../components/signup-review/CheckoutPreview';
import { findReviewPlan, reviewPlanId } from '../components/signup-review/reviewPlans';
import '../components/signup-review/signup-review.css';

// Deliberately isolated from AuthContext, storage, network and payment SDKs.
const SignupReviewFlow = ({ initialPlan, paymentPreview }) => {
  const [step, setStep] = useState(paymentPreview ? 'checkout' : 'account');
  const [planId, setPlanId] = useState(initialPlan);
  const [form, setForm] = useState(paymentPreview ? { name: 'Taylor Morgan', email: 'taylor@example.com', password: '', business: 'Morgan Growth Agency' } : { name: '', email: '', password: '', business: '' });
  const reducedMotion = useReducedMotion();
  const plan = findReviewPlan(planId);
  const googlePreview = () => {
    setForm(current => ({ ...current, name: 'Taylor Morgan', email: 'taylor@example.com', password: '' }));
    setStep('business');
  };
  const restart = () => { setForm({ name: '', email: '', password: '', business: '' }); setPlanId(initialPlan); setStep('account'); };
  useEffect(() => {
    // Only focus subsequent screens; don't pop the keyboard on initial mobile entry.
    if (step !== 'account') document.querySelector('[data-testid="signup-review-heading"]')?.focus({ preventScroll: true });
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [step]);
  return <ReviewShell step={step}>
    <motion.div key={step} initial={reducedMotion ? false : { opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .18 }}>
      {step === 'account' && <AccountDetails form={form} setForm={setForm} onContinue={() => setStep('business')} onGooglePreview={googlePreview} />}
      {step === 'business' && <BusinessDetails form={form} setForm={setForm} onContinue={() => setStep('plans')} onBack={() => setStep('account')} />}
      {step === 'plans' && <PlanSelection plan={plan} onSelect={setPlanId} onBack={() => setStep('business')} onContinue={() => { if (plan) setStep('checkout'); }} />}
      {step === 'checkout' && <CheckoutPreview form={form} plan={plan} onBack={() => setStep('plans')} onComplete={() => { setForm(current => ({ ...current, password: '' })); setStep('success'); }} />}
      {step === 'success' && <ConfirmationPreview name={form.name} onRestart={restart} />}
    </motion.div>
  </ReviewShell>;
};

export default function SignupReviewPage() {
  const [params] = useSearchParams();
  useLayoutEffect(() => {
    document.documentElement.classList.add('signup-review-viewport');
    const previousTitle = document.title;
    document.title = 'Paid signup · Design preview — Voxinity AI';
    return () => { document.documentElement.classList.remove('signup-review-viewport'); document.title = previousTitle; };
  }, []);
  const paymentPreview = params.get('screen') === 'payment';
  return <SignupReviewFlow key={params.toString()} initialPlan={reviewPlanId(params.get('plan')) || (paymentPreview ? 'agency' : null)} paymentPreview={paymentPreview} />;
}